import { motion } from "framer-motion";
import { Clock, MapPin, Navigation, MessageSquare, Phone } from "lucide-react";
import { Chapter } from "@/components/landing/Chapter";

const HOURS = [
  { day: "Lundi — Vendredi", time: "09:00 – 12:00 · 14:00 – 19:00" },
  { day: "Samedi", time: "09:00 – 14:00" },
  { day: "Dimanche", time: "Fermé", closed: true },
];

const MAPS_DIR =
  "https://www.google.com/maps/dir/?api=1&destination=56+Avenue+d'Oyonnax,+01100+Bellignat";
const MAP_EMBED =
  "https://maps.google.com/maps?q=56%20Avenue%20d'Oyonnax%2C%2001100%20Bellignat&t=&z=15&ie=UTF8&iwloc=&output=embed";

export const Horaires = ({ onNavigate }) => (
  <section id="horaires" data-testid="horaires-section" className="relative py-24 lg:py-36">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Chapter num="06" title="Horaires & accès" accent="Bellignat · Ain (01)" />

      <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-stretch">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="flex flex-col"
        >
          <div className="rounded-md border border-white/10 bg-[#0E1322] divide-y divide-white/5">
            {HOURS.map((h) => (
              <div key={h.day} className="flex items-center justify-between px-6 py-5">
                <div className="flex items-center gap-3">
                  <Clock className={`w-4 h-4 ${h.closed ? "text-slate-500" : "text-[#00E5FF]"}`} />
                  <span className="font-semibold text-sm md:text-base">{h.day}</span>
                </div>
                <span className={`font-mono-tech text-xs md:text-sm ${h.closed ? "text-slate-500" : "text-white"}`}>
                  {h.time}
                </span>
              </div>
            ))}
          </div>

          <div className="mt-8 flex items-start gap-3 text-slate-300">
            <MapPin className="w-5 h-5 text-[#0066FF] shrink-0 mt-0.5" />
            <div>
              <div className="font-display font-bold text-lg">AUTO MECA PRO — AMP Services 01</div>
              <div className="text-sm text-slate-400 mt-1">56 Avenue d'Oyonnax, 01100 Bellignat</div>
              <div className="text-sm text-slate-500 mt-1">À 2 minutes du centre d'Oyonnax, axe Nantua – Genève.</div>
              <div className="mt-3 flex flex-col gap-1">
                <a data-testid="horaires-phone-link" href="tel:+33426612733" className="font-display font-bold text-xl text-white hover:text-[#00E5FF] transition-colors duration-300">04 26 61 27 33</a>
                <a data-testid="horaires-email-link" href="mailto:contact@automecapro01.com" className="text-sm text-slate-400 hover:text-white transition-colors duration-300">contact@automecapro01.com</a>
              </div>
            </div>
          </div>

          <div className="mt-10 flex flex-wrap gap-4">
            <a
              data-testid="horaires-call-button"
              href="tel:+33426612733"
              className="rounded-full bg-[#0066FF] hover:bg-[#0052CC] text-white font-semibold px-6 py-3 flex items-center gap-2 transition-[background-color,box-shadow] duration-300 hover:shadow-[0_0_28px_rgba(0,102,255,0.5)]"
            >
              <Phone className="w-4 h-4" />
              Appeler
            </a>
            <a
              data-testid="horaires-itineraire-button"
              href={MAPS_DIR}
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-full bg-[#0066FF] hover:bg-[#0052CC] text-white font-semibold px-6 py-3 flex items-center gap-2 transition-[background-color,box-shadow] duration-300 hover:shadow-[0_0_28px_rgba(0,102,255,0.5)]"
            >
              <Navigation className="w-4 h-4" />
              Itinéraire
            </a>
            <a
              data-testid="horaires-contact-button"
              href="#contact"
              onClick={(e) => {
                if (onNavigate) {
                  e.preventDefault();
                  onNavigate("#contact");
                }
              }}
              className="rounded-full border border-white/20 hover:border-[#0066FF] text-white font-semibold px-6 py-3 flex items-center gap-2 transition-[border-color,background-color] duration-300 hover:bg-[#0066FF]/10"
            >
              <MessageSquare className="w-4 h-4" />
              Nous écrire
            </a>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.97 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="relative rounded-md overflow-hidden border border-white/10 min-h-[360px]"
          style={{ clipPath: "polygon(0 0, 100% 0, 100% calc(100% - 40px), calc(100% - 40px) 100%, 0 100%)" }}
        >
          <iframe
            data-testid="horaires-map"
            title="Plan d'accès AUTO MECA PRO Bellignat"
            src={MAP_EMBED}
            className="absolute inset-0 w-full h-full map-dark"
            loading="lazy"
          />
        </motion.div>
      </div>
    </div>
  </section>
);
